import React, { ReactNode, useContext } from 'react';
import HeaderContext from './context/HeaderContext';
import HeaderVariantType from './types/HeaderVariantType';

export interface HeaderTitleProps {
  children: ReactNode;
}

const HeaderTitle = ({ children }: HeaderTitleProps): JSX.Element => {
  const { headerVariant } = useContext(HeaderContext);
  return (
    <div className="usa-logo" id={headerVariant === HeaderVariantType.Basic ? 'basic-logo' : 'extended-logo'}>
      <em className="usa-logo__text">{children}</em>
    </div>
  );
};

export default HeaderTitle;
